/**
 * isNumber
 * @param input
 * @returns {boolean}
 */
export const isNumber = (input) => {
  // supports all modern browsers, NOT IE
  return Number.isFinite(input);
};
